import { RootStore } from "./RootStore";
import {
  getBasicData,
  getBoardsData,
  getBoardsDashboard,
  getGamesData,
  getScansData,
  getPartnersData,
  getDetailedPartnersData,
} from "../vendor";
import { TypeGetBoardsDashboard, ScanType } from "../vendor/types";

export class DashboardStore {
  protected rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  public getDetailedPartnersData = async (
    where: {
      partnerIds?: string[] | null;
      period?: {
        dateInit: string | null;
        dateEnd: string | null;
      };
    } | null = null
  ) => {
    try {
      return await getDetailedPartnersData(where);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter os dados do Dashboard.",
        "error"
      );
      return null;
    }
  };

  public getPartnersData = async (
    where: {
      partnerIds?: string[] | null;
      period?: {
        dateInit: string | null;
        dateEnd: string | null;
      };
    } | null = null
  ) => {
    try {
      return await getPartnersData(where);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter os dados do Dashboard.",
        "error"
      );
      return null;
    }
  };

  public getScansData = async (
    where: {
      partnerIds?: string[] | null;
      scanTypes?: ScanType[] | null;
      period?: {
        dateInit: string | null;
        dateEnd: string | null;
      };
      groupBy?: "all" | "date" | "partner" | "scanType" | null;
    } | null = null
  ) => {
    try {
      return await getScansData(where);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter os dados do Dashboard.",
        "error"
      );
      return null;
    }
  };

  public getGamesData = async () => {
    try {
      return await getGamesData();
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter os dados do Dashboard.",
        "error"
      );
      return null;
    }
  };

  public getBasicData = async () => {
    try {
      return await getBasicData();
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter os dados do Dashboard.",
        "error"
      );
      return null;
    }
  };

  public getBoardsData = async () => {
    try {
      return await getBoardsData();
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter os dados do Dashboard.",
        "error"
      );
      return null;
    }
  };

  public getBoardsDashboard = async (
    type: TypeGetBoardsDashboard,
    partnerOrDepositId?: number
  ) => {
    try {
      return await getBoardsDashboard(type, partnerOrDepositId);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter os dados das Placas.",
        "error"
      );
      return null;
    }
  };
}
